// extracted by mini-css-extract-plugin
export default {"main-document":"AccessDenied_main-document__LzfOH","img":"AccessDenied_img__eu1Eq"};